import React from 'react';
import Icon from '../../../components/AppIcon';

const WeekView = ({ startDate, appointments, onAppointmentClick, onSlotClick }) => {
  const days = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(startDate);
    date?.setDate(date?.getDate() + i);
    return date;
  });

  const hours = Array.from({ length: 13 }, (_, i) => i + 8);

  const getAppointmentsForSlot = (date, hour) => {
    return appointments?.filter(apt => {
      const aptDate = new Date(apt.startTime);
      return (aptDate?.getDate() === date?.getDate() &&
      aptDate?.getMonth() === date?.getMonth() && aptDate?.getHours() === hour);
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success/10 border-success text-success';
      case 'pending':
        return 'bg-warning/10 border-warning text-warning';
      case 'cancelled':
        return 'bg-muted border-border text-muted-foreground line-through';
      case 'completed':
        return 'bg-primary/10 border-primary text-primary';
      default:
        return 'bg-muted border-border text-foreground';
    }
  };

  const isToday = (date) => {
    const today = new Date();
    return (date?.getDate() === today?.getDate() &&
    date?.getMonth() === today?.getMonth() && date?.getFullYear() === today?.getFullYear());
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[900px]">
        <div className="grid grid-cols-[80px_repeat(7,1fr)] border-b border-border">
          <div className="p-4 bg-muted"></div>
          {days?.map((day, idx) => (
            <div
              key={idx}
              className={`p-4 text-center border-l border-border ${
                isToday(day) ? 'bg-primary/10' : 'bg-muted'
              }`}
            >
              <p className="text-xs text-muted-foreground uppercase">
                {day?.toLocaleDateString('en-US', { weekday: 'short' })}
              </p>
              <p className={`text-lg font-semibold mt-1 ${
                isToday(day) ? 'text-primary' : 'text-foreground'
              }`}>
                {day?.getDate()}
              </p>
            </div>
          ))}
        </div>

        {hours?.map((hour) => (
          <div key={hour} className="grid grid-cols-[80px_repeat(7,1fr)] border-b border-border min-h-[100px]">
            <div className="p-4 bg-muted/50 text-sm font-medium text-foreground">
              {hour === 12 ? '12:00 PM' : hour > 12 ? `${hour - 12}:00 PM` : `${hour}:00 AM`}
            </div>
            {days?.map((day, idx) => {
              const slotAppointments = getAppointmentsForSlot(day, hour);
              return (
                <div
                  key={idx}
                  className={`border-l border-border p-2 transition-smooth hover:bg-muted/30 cursor-pointer ${
                    isToday(day) ? 'bg-primary/5' : ''
                  }`}
                  onClick={() => slotAppointments?.length === 0 && onSlotClick(day, hour)}
                >
                  {slotAppointments?.length === 0 ? (
                    <div className="flex items-center justify-center h-full text-xs text-muted-foreground">
                      Available
                    </div>
                  ) : (
                    <div className="space-y-1">
                      {slotAppointments?.map((apt) => (
                        <button
                          key={apt?.id}
                          onClick={(e) => {
                            e?.stopPropagation();
                            onAppointmentClick(apt);
                          }}
                          className={`w-full p-2 rounded border text-left text-xs transition-smooth hover:shadow-md ${getStatusColor(apt?.status)}`}
                        >
                          <p className="font-medium truncate">{apt?.patientName}</p>
                          <p className="opacity-90 truncate mt-1">{apt?.type}</p>
                          <div className="flex items-center gap-1 mt-1">
                            <Icon name="Clock" size={10} />
                            <span>{apt?.duration}m</span>
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeekView;